import {koloProfile} from './koloprofile.reducer'

export default {
  koloProfile
}
